import { alpha, Select, styled } from '@mui/material';

export const StyledSelect = styled(Select)(({ theme }) => ({
  backgroundColor: '#fff',
  '& .MuiDivider-root': {
    backgroundColor: '#d3d4d7',
  },
  '& .MuiButtonBase-root.MuiMenuItem-root.Mui-selected.Mui-focusVisible': {
    backgroundColor: alpha('#ccf0f9', 0.6),
  },
  '& .MuiButtonBase-root.MuiMenuItem-root.Mui-selected': {
    backgroundColor: '#fff',
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: `${theme.palette.primary.main} !important`,
  },
}));
